
export const DOMUtils = {

    removeAllAttributes(node: HTMLElement): HTMLElement  {
        const names = node.getAttributeNames();
        names.forEach(name => node.removeAttribute(name));
        return node;
    },

    copyAttributes(from: HTMLElement, to: HTMLElement): HTMLElement {
        const names = from.getAttributeNames();
        names.forEach(name => to.setAttribute(name,from.getAttribute(name)));
        return to;
    },

    clone(node: HTMLElement): HTMLElement {
        return node.cloneNode(true) as HTMLElement;
    }

}
